import React from "react";
import { Row, Col, Form, Button } from "antd";
import { withFormik } from "formik";
import FormikPersist from "src/components/FormikPersist";
import {
    Field,
    RenderCheckBox,
    RenderField,
    RenderSelect,
} from "src/components";
import { Select } from "antd";
import { useAuth0 } from "@auth0/auth0-react";

import { useRouter } from "src/helpers";
import * as yup from "yup";

const Option = Select.Option;

const subjects = [
    "Maths",
    "Science",
    "Physics",
    "Biology",
    "Chemistry",
    "Environmental Studies",
    "English",
    "Social Studies",
    "Social Science",
    "Hindi",
];

const classNames = [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
];

const TopicForm = (props) => {
    const { onFinishFailed, values, handleSubmit, isSubmitting } = props;
    // console.log("🚀 ~ file: index.tsx ~ line 8 ~ values", values);

    return (
        <Form onFinish={handleSubmit} onFinishFailed={onFinishFailed}>
            {typeof window !== "undefined" && !isSubmitting && (
                <FormikPersist name={window?.location?.pathname} />
            )}

            <Row gutter={24}>
                <Col lg={24} md={24}>
                    <Field
                        label="Topic Title"
                        placeholder="Topic Title"
                        name={"title"}
                        icon="FontSizeOutlined"
                        component={RenderField}
                        type="text"
                        value={values.title}
                        rules={[{ required: true }]}
                    />
                </Col>

                <Col lg={24} md={24}>
                    <Field
                        label="Topic Description"
                        placeholder="Topic Description"
                        name={"description"}
                        icon="FontSizeOutlined"
                        component={RenderField}
                        type="textarea"
                        value={values.description}
                        rules={[{ required: true }]}
                    />
                </Col>

                <Col lg={12} md={24}>
                    <Field
                        label="Topic Status"
                        placeholder="Topic Status"
                        name={"status"}
                        icon="FontSizeOutlined"
                        component={RenderSelect}
                        type="text"
                        value={values.status}
                        rules={[{ required: true }]}
                    >
                        <Option value="inactive">Inactive</Option>
                        <Option value="active">Active</Option>
                    </Field>
                </Col>

                <Col lg={24} md={24}>
                    <Field
                        label="Topic is locked?"
                        placeholder="Topic is locked?"
                        name={"other.is_locked"}
                        icon="FontSizeOutlined"
                        component={RenderCheckBox}
                        checked={values.other.is_locked}
                        rules={[{ required: true }]}
                    />
                </Col>

                <Col lg={12} md={24}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={isSubmitting}
                    >
                        Submit
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export const FormSchema = yup.object().shape({
    title: yup.string().required("This field is required"),
    status: yup.string().required("This field is required"),
    type: yup.string().required("This field is required"),
    parent_id: yup.number().required("This field is required"),
});

const TopicFormWithFormik = withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props: any) => {
        const { topic, chapter_id, order } = props;

        return {
            ...(topic?.id ? { id: topic.id } : {}),
            title: topic?.title || "",
            description: topic?.description || "",

            status: topic?.status || "inactive",
            type: "topic",
            parent_id: topic?.parent_id || parseInt(chapter_id),
            other: {
                ...(topic?.other || { order }),
                is_locked: topic?.other?.is_locked || false,
            },
            // created_by: props.user_id,
        };
    },
    validationSchema: FormSchema,

    async handleSubmit(values, { props: { onFinish } }: any) {
        await onFinish(values);
        // console.log(values);
    },
    ...(typeof window !== "undefined" && {
        displayName: window?.location?.pathname, // helps with React DevTools
    }),
});

const FormikForm = TopicFormWithFormik(TopicForm);
const FormikFormWithUser = (props) => {
    const { query } = useRouter();
    const { chapter_id } = query;

    const { user } = useAuth0();

    const namespace = "https://hasura.io/jwt/claims/";
    const user_id = user && user[namespace + "user_id"];
    return <FormikForm {...props} user_id={user_id} chapter_id={chapter_id} />;
};

export default FormikFormWithUser;
